import {
  createBackground,
  getCreativeView,
  getRandomCreativeAsset,
  renderCreativeView,
} from './core';
import { preloadImages } from '../lib/utils';
import { user } from 'src/StateObserver';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView, {
  LangBitmapOpts,
} from 'src/lib/ui/components/LangBitmapFontTextView';
import { nativeShareInviteAssets } from 'src/replicant/chatbot/flex/invite';
import { GENERIC_AVATAR } from 'src/replicant/profile/assets';

/**
 * Creative IDs for native share invites
 */
export type NativeShareCreativeID = keyof typeof nativeShareInviteAssets;

/**
 * Choose random creative for ab test
 */
export function getRandomStaticShareInviteCreative() {
  return getRandomCreativeAsset('2024-12-18', [
    () =>
      Promise.resolve({
        id: 'web_share_crying_ja' as NativeShareCreativeID,
        image: 'web_share_crying_ja' as NativeShareCreativeID,
      }),

    () =>
      Promise.resolve({
        id: 'web_share_egg_ja' as NativeShareCreativeID,
        image: 'web_share_egg_ja' as NativeShareCreativeID,
      }),
    () =>
      Promise.resolve({
        id: 'web_share_sleep_ja' as NativeShareCreativeID,
        image: 'web_share_sleep_ja' as NativeShareCreativeID,
      }),
  ]) as Promise<{ id: NativeShareCreativeID; image: NativeShareCreativeID }>;
}

/**
 * Choose random creative for Add Friends V2
 */
export function getRandomAddFriendsV2ShareCreative() {
  return getRandomCreativeAsset('2026-01-09', [
    () =>
      Promise.resolve({
        id: 'web_addingasfriend_A_ja' as NativeShareCreativeID,
        image: 'web_addingasfriend_A_ja' as NativeShareCreativeID,
      }),
    () =>
      Promise.resolve({
        id: 'web_addingasfriend_B_ja' as NativeShareCreativeID,
        image: 'web_addingasfriend_B_ja' as NativeShareCreativeID,
      }),
    () =>
      Promise.resolve({
        id: 'web_addingasfriend_C_ja' as NativeShareCreativeID,
        image: 'web_addingasfriend_C_ja' as NativeShareCreativeID,
      }),
    () =>
      Promise.resolve({
        id: 'web_addingasfriend_D_ja' as NativeShareCreativeID,
        image: 'web_addingasfriend_D_ja' as NativeShareCreativeID,
      }),
  ]) as Promise<{ id: NativeShareCreativeID; image: NativeShareCreativeID }>;
}

/**
 * Choose random creative for ab test
 */
export function getRandomShareInviteCreative() {
  return getRandomCreativeAsset('2024-04-25', [
    // ORIGINALS - 2 CREATIVES
    () => {
      return createInviteShare({
        id: 'BD_ST_U2U_PL_1024x1024_14',
        width: 1024,
        height: 1024,
      });
    },
    () => {
      return createInviteShare({
        id: 'U2U_viralmessage_1040x1040_6',
        width: 1040,
        height: 1040,
        localized: true,
      });
    },
    // NEW SET: 01 MAR 2024 - 1 CREATIVE
    () => {
      return createInviteShare({
        id: 'U2U_viralmessage_1040x1040_13',
        width: 1040,
        height: 1040,
        localized: true,
      });
    },
    // // NEW SET: 24 APR 2024 - 10 CREATIVE
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_01_sleepparty',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_02_pimples',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_03_poop',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_04_angelvsdevil',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_05_debutroom',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_06_cage',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_07_balloonbear',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_08_livingroom',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_09_kitchenonfire',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
    // () => {
    //   return createInviteShare({
    //     id: 'U2U_viralmessage_10_bathortoilet',
    //     width: 1080,
    //     height: 1674,
    //     localized: true,
    //     template: 'dynamic-tall-borderless',
    //     templateType: 'flex',
    //   });
    // },
  ]);
}

/**
 * New test assets invite creative
 */
async function createInviteShare(args: {
  id: string;
  width: number;
  height: number;
  localized?: boolean;
}) {
  const { id, width, height, localized } = args;
  const superview = getCreativeView(width, height);

  const image = `assets/creatives/invites/${id}${
    localized ? `_${user().settings.locale}` : ''
  }.png`;

  await preloadImages([image]);

  createBackground({ superview, image });

  return renderCreativeView(`${id}`, superview);
}

async function createInviteShareWithAvatar(args: {
  id: string;
  width: number;
  height: number;
  prefix: string;
  localized?: boolean;
  avatarPosition?: { x: number; y: number };
}) {
  const { id, width, height, localized } = args;
  const superview = getCreativeView(width, height);

  const image = `assets/creatives/invites/${id}${
    localized ? `_${user().settings.locale}` : ''
  }.png`;
  const avatar = user().publicProfile?.photo ?? GENERIC_AVATAR;

  await preloadImages([image, avatar]);

  new ImageScaleView({
    superview,
    image: avatar,
    width: 200,
    height: 200,
    x: args.avatarPosition?.x ?? 120,
    y: args.avatarPosition?.y ?? 120,
    centerOnOrigin: true,
  });

  createBackground({ superview, image });

  return renderCreativeView(
    `${args.prefix ? `${args.prefix}-` : ''}${id}`,
    superview,
  );
}

async function createInviteShareWithAvatarAndText(args: {
  id: string;
  width: number;
  height: number;
  prefix: string;
  localized?: boolean;
  avatarPosition?: { x: number; y: number };
  text: LangBitmapOpts;
}) {
  const { id, width, height, localized } = args;
  const superview = getCreativeView(width, height);

  const image = `assets/creatives/invites/${id}${
    localized ? `_${user().settings.locale}` : ''
  }.png`;
  const avatar = user().publicProfile?.photo ?? GENERIC_AVATAR;

  await preloadImages([image, avatar]);

  new ImageScaleView({
    superview,
    image: avatar,
    width: 200,
    height: 200,
    x: args.avatarPosition?.x ?? 120,
    y: args.avatarPosition?.y ?? 120,
    centerOnOrigin: true,
  });

  createBackground({ superview, image });

  new LangBitmapFontTextView({
    superview,
    font: 'Body',
    color: '#775431',
    size: 47,
    wordWrap: true,
    ...args.text,
  });

  return renderCreativeView(
    `${args.prefix ? `${args.prefix}-` : ''}${id}`,
    superview,
  );
}
